import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { Link } from '../../../partials/link/Link';

export interface LogoProps {
    svgLarge: string,
    svgSmall: string,
    svgLargeViewBox: string
    svgSmallViewBox: string
    alt: string,
    href: string,
}

const getLogoStyle = () => {
  return StyleSheet.create({
    base: {
      height: '24px',
      alignItems: 'center',
    },
    largeSvg: {
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        display: 'none',
      },
    },
    smallSvg: {
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        display: 'inline-flex',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        display: 'inline-flex',
      },
    },
    image: {
      height: '100%',
    },
  });
};

export const Logo: React.FunctionComponent<LogoProps> = props => {
  const { href, alt, svgLarge, svgSmall } = props;
  const style = getLogoStyle();

  return (
    <React.Fragment>
      <Link className={css(style.largeSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={`data:image/svg+xml,${encodeURIComponent(svgLarge)}`} />
      </Link>
      <Link className={css(style.smallSvg, style.base)} href={href}>
        <img className={css(style.image)} alt={alt} src={`data:image/svg+xml,${encodeURIComponent(svgSmall)}`} />
      </Link>
    </React.Fragment>
  );
};
